import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const causes = [
  { id: "huellitas", label: "San7as Huellitas", icon: "ri-footprint-line" },
  { id: "equipo", label: "Equipo Inclusivo", icon: "ri-team-line" },
  { id: "menu", label: "Menú Accesible", icon: "ri-eye-off-line" },
];

export default function CausasPage() {
  const [activeCause, setActiveCause] = useState("huellitas");

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[80vh] min-h-[580px] flex items-end pb-16">
        <img
          src="https://readdy.ai/api/search-image?query=flat%20lay%20of%20artisan%20pastries%20macarons%20and%20cakes%20on%20white%20marble%20surface%2C%20dominant%20aqua%20teal%20cyan%20color%20palette%20with%20turquoise%20ribbons%20flowers%20and%20decorations%2C%20minimal%20pink%20accents%2C%20top%20view%20overhead%20shot%2C%20no%20people%2C%20elegant%20food%20photography%2C%20soft%20natural%20light%2C%20pasteleria%20artesanal%2C%20high%20detail%2C%20fresh%20and%20modern%20aesthetic&width=1440&height=800&seq=causas-hero-v6&orientation=landscape"
          alt="Causas Sociales San7o Pecado"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>
        <div className="relative z-10 w-full px-4 md:px-8 pt-20 text-center">
          <div className="inline-flex items-center gap-2 bg-[#f9b8c8]/20 border border-[#f9b8c8]/40 rounded-full px-5 py-2 mb-5">
            <i className="ri-heart-fill text-[#f9b8c8]"></i>
            <span className="text-[#f9b8c8] text-xs font-semibold uppercase tracking-widest">
              Más que una pastelería
            </span>
          </div>
          <h1
            className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight"
          >
            Nuestras Causas Sociales
          </h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto mb-10">
            En San7o Pecado creemos que un negocio puede ser delicioso <em>y</em> transformador. Aquí te contamos cómo.
          </p>
          {/* Cause Tabs */}
          <div className="flex flex-wrap justify-center gap-3">
            {causes.map((c) => (
              <button
                key={c.id}
                onClick={() => {
                  setActiveCause(c.id);
                  const el = document.getElementById(c.id);
                  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeCause === c.id
                    ? "bg-[#d4607a] text-white"
                    : "bg-white/15 text-white border border-white/30 hover:bg-white/25"
                }`}
              >
                <i className={c.icon}></i>
                {c.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAUSA 1: SANTAS HUELLITAS ── */}
      <section id="huellitas" className="py-24 bg-white scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#e0f7fa] rounded-full px-4 py-1.5 mb-4">
              <i className="ri-footprint-line text-[#00b4c8]"></i>
              <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">Causa 01</span>
            </div>
            <h2
              className="text-3xl md:text-5xl font-bold text-[#2d1a0e] mb-4"
            >
              Fundación San7as Huellitas
            </h2>
            <p className="text-[#6b5b6e] text-base max-w-2xl mx-auto leading-relaxed">
              Cada compra que realizas contribuye al rescate, cuidado y adopción de perritos que merecen una segunda oportunidad.
            </p>
          </div>

          {/* Story */}
          <div className="flex flex-col lg:flex-row gap-12 items-center mb-20">
            <div className="lg:w-1/2">
              <img
                src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/def93d47476ef44f2e51a6321b2842a2.png"
                alt="Historia San7as Huellitas"
                className="w-full h-[480px] object-cover object-center rounded-3xl"
              />
            </div>
            <div className="lg:w-1/2">
              <div className="flex items-center gap-4 mb-5">
                <img
                  src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/8db8aa41c94b113edaa0ef92042e954f.png"
                  alt="San7as Huellitas Logo"
                  className="w-16 h-16 rounded-full object-cover flex-shrink-0"
                />
                <a
                  href="https://www.instagram.com/san7as.huellitas/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#d4607a] hover:text-[#b84d65] transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-2xl"></i>
                  <span className="text-sm font-semibold">@san7as.huellitas</span>
                </a>
              </div>
              <h3
                className="text-2xl md:text-3xl font-bold text-[#2d1a0e] mb-5"
              >
                Una Fundación Nacida del Amor
              </h3>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-6">
                Hoy, la Fundación San7as Huellitas trabaja con albergues locales para rescatar, rehabilitar y encontrar hogares amorosos para perritos abandonados. Un porcentaje de cada venta de nuestros productos solidarios va directamente a cubrir gastos veterinarios, alimentación y cuidados.
              </p>
              <div className="grid grid-cols-3 gap-3">
                {[
                  { icon: "ri-heart-line", title: "Rescate", desc: "Con albergues locales" },
                  { icon: "ri-stethoscope-line", title: "Rehabilitación", desc: "Gastos veterinarios" },
                  { icon: "ri-home-heart-line", title: "Adopción", desc: "Familias amorosas" },
                ].map((item) => (
                  <div key={item.title} className="bg-[#e0f7fa] rounded-xl p-4 text-center">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#00b4c8]/20 mx-auto mb-2">
                      <i className={`${item.icon} text-base text-[#00b4c8]`}></i>
                    </div>
                    <p className="font-bold text-[#2d1a0e] text-xs">{item.title}</p>
                    <p className="text-[#6b5b6e] text-xs mt-0.5">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CAUSA 2: EQUIPO INCLUSIVO ── */}
      <section id="equipo" className="py-24 bg-[#fafeff] scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#c9b8f0]/30 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-team-line text-[#7c5cbf]"></i>
              <span className="text-xs font-semibold text-[#7c5cbf] uppercase tracking-widest">Causa 02</span>
            </div>
            <h2
              className="text-3xl md:text-5xl font-bold text-[#2d1a0e] mb-4"
            >
              Equipo Diverso e Inclusivo
            </h2>
            <p className="text-[#6b5b6e] text-base max-w-2xl mx-auto leading-relaxed">
              En San7o Pecado creemos que el talento no tiene límites. Somos un espacio donde personas con capacidades diferentes encuentran un lugar real de trabajo, crecimiento y pertenencia.
            </p>
          </div>

          {/* Main content */}
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-20">
            <div className="lg:w-1/2 order-2 lg:order-1">
              <h3
                className="text-2xl md:text-3xl font-bold text-[#2d1a0e] mb-5"
              >
                Porque el talento no tiene una sola forma
              </h3>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-4">
                En San7o Pecado abrimos las puertas a personas con capacidades diferentes, brindándoles un espacio real de trabajo donde son valoradas por lo que son y por lo que aportan.
              </p>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-8">
                No es caridad — es reconocer que cuando das oportunidades reales, recibes dedicación, creatividad y pasión que no encuentras en ningún otro lugar. Cada pieza que sale de nuestra cocina lleva el trabajo de manos extraordinarias.
              </p>
            </div>
            <div className="lg:w-1/2 order-1 lg:order-2">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/39360a38feac9c20eb5c676d8820981a.png"
                  alt="Equipo Inclusivo San7o Pecado"
                  className="w-full h-[480px] object-cover object-center rounded-3xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 max-w-[220px]">
                  <p className="text-lg font-bold text-[#7c5cbf] leading-snug">De las pocas empresas en México</p>
                  <p className="text-xs text-[#6b5b6e] mt-1 leading-snug">que apoya activamente el empleo de personas con capacidades diferentes</p>
                </div>
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: "ri-award-line",
                title: "Salario justo",
                desc: "Todos nuestros colaboradores reciben el mismo salario sin importar sus capacidades. Cero diferencias.",
                color: "text-[#d4607a]",
                bg: "bg-[#fff0f5]",
              },
              {
                icon: "ri-tools-line",
                title: "Adaptación real",
                desc: "Modificamos estaciones de trabajo, procesos y herramientas para que cada persona pueda dar lo mejor de sí.",
                color: "text-[#7c5cbf]",
                bg: "bg-[#f5f0ff]",
              },
              {
                icon: "ri-seedling-line",
                title: "Crecimiento continuo",
                desc: "Capacitación constante, ascensos reales y un ambiente donde todos pueden crecer profesionalmente.",
                color: "text-[#3a9e7c]",
                bg: "bg-[#f0faf5]",
              },
            ].map((item) => (
              <div key={item.title} className={`${item.bg} rounded-2xl p-7`}>
                <div className={`w-12 h-12 flex items-center justify-center rounded-full bg-white mb-4`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <h4 className="font-bold text-[#2d1a0e] mb-2">{item.title}</h4>
                <p className="text-[#6b5b6e] text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAUSA 3: MENÚ ACCESIBLE ── */}
      <section id="menu" className="py-24 bg-white scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#fde68a]/30 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-eye-off-line text-[#b08000]"></i>
              <span className="text-xs font-semibold text-[#b08000] uppercase tracking-widest">Causa 03</span>
            </div>
            <h2
              className="text-3xl md:text-5xl font-bold text-[#2d1a0e] mb-4"
            >
              Menú Accesible para Ciegos
            </h2>
            <p className="text-[#6b5b6e] text-base max-w-2xl mx-auto leading-relaxed">
              Somos de los pocos lugares en México con un menú completamente accesible para personas con discapacidad visual. Porque disfrutar de un buen postre es un derecho, no un privilegio.
            </p>
          </div>

          {/* Main content */}
          <div className="flex flex-col lg:flex-row gap-14 items-center mb-20">
            <div className="lg:w-1/2">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/707e9a4f9368999593f702b6caac5116/82d2c022dbbd6e47e6f4b6735249f553.png"
                  alt="Menú en Braille San7o Pecado"
                  className="w-full h-[420px] object-cover object-center rounded-3xl"
                />
                <div className="absolute -bottom-6 -right-6 bg-[#00b4c8] rounded-2xl p-5 max-w-[220px]">
                  <p className="text-sm font-bold text-white leading-snug">Con el apoyo de la Defensoría de Derechos Humanos de Metepec</p>
                  <p className="text-xs text-white/80 mt-1 leading-snug">para garantizar accesibilidad real en cada visita</p>
                </div>
              </div>
            </div>
            <div className="lg:w-1/2">
              <h3
                className="text-2xl md:text-3xl font-bold text-[#2d1a0e] mb-5"
              >
                Porque todos merecen elegir su postre favorito
              </h3>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-4">
                Desarrollamos nuestro menú en Braille gracias al apoyo de la Defensoría de Derechos Humanos de Metepec, asegurándonos de que cada descripción sea clara, precisa y apetitosa. No es solo una traducción — es una experiencia diseñada para que las personas con discapacidad visual puedan explorar, preguntar y elegir con total autonomía.
              </p>
              <p className="text-[#6b5b6e] text-sm leading-relaxed mb-8">
                Además, nuestro personal está capacitado para acompañar a clientes con discapacidad visual, describir texturas, sabores y presentaciones con detalle, y hacer que cada visita sea memorable.
              </p>
              {/* Features */}
              <div className="space-y-3">
                {[
                  {
                    icon: "ri-book-open-line",
                    title: "Menú completo en Braille",
                    desc: "Todos los productos, precios y descripciones disponibles en sistema Braille actualizado.",
                  },
                  {
                    icon: "ri-user-voice-line",
                    title: "Personal capacitado",
                    desc: "Todo nuestro equipo está entrenado para asistir con calidez y precisión a clientes con discapacidad visual.",
                  },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4 bg-[#fde68a]/20 rounded-2xl p-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white flex-shrink-0">
                      <i className={`${item.icon} text-lg text-[#00b4c8]`}></i>
                    </div>
                    <div>
                      <p className="font-bold text-sm text-[#2d1a0e]">{item.title}</p>
                      <p className="text-[#6b5b6e] text-xs leading-relaxed mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section className="py-20 bg-gradient-to-br from-[#00b4c8] via-[#0099aa] to-[#007a8a] text-center px-4">
        <div className="max-w-3xl mx-auto">
          <div className="flex justify-center gap-4 mb-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#d4607a]/20">
              <i className="ri-footprint-line text-[#f9b8c8] text-xl"></i>
            </div>
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#7c5cbf]/20">
              <i className="ri-team-line text-[#c9b8f0] text-xl"></i>
            </div>
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#e07b3a]/20">
              <i className="ri-eye-off-line text-[#ffd4a8] text-xl"></i>
            </div>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-white mb-4"
          >
            Cada compra es un acto de amor
          </h2>
          <p className="text-white/70 text-base mb-8 leading-relaxed">
            Cuando eliges San7o Pecado, apoyas a perritos rescatados, a un equipo diverso e inclusivo y a un espacio donde todos son bienvenidos. Gracias por ser parte de esto.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/menu"
              className="inline-flex items-center gap-2 bg-[#d4607a] text-white font-semibold text-sm px-8 py-4 rounded-full hover:bg-[#b84d65] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-restaurant-line"></i> Ver el Menú
            </a>
            <a
              href="https://wa.me/5217291317070?text=Hola! Quiero saber más sobre las causas sociales de San7o Pecado"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white/10 border border-white/30 text-white font-semibold text-sm px-8 py-4 rounded-full hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i> Contáctanos
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}